console.log('🚀 GM Performance Analytics Store: Initializing performance analytics module...');

const performanceAnalytics = {
  namespaced: true,

  state: {
    performanceData: {},
    agentData: {},
    teamData: {},
    isLoading: false,
    error: null
  },

  mutations: {
    SET_PERFORMANCE_DATA(state, data) {
      console.log('⚡ GM Performance Analytics: Setting performance data:', data);
      state.performanceData = data;
    },

    SET_AGENT_DATA(state, data) {
      console.log('⚡ GM Performance Analytics: Setting agent data:', data);
      state.agentData = data;
    },

    SET_TEAM_DATA(state, data) {
      console.log('⚡ GM Performance Analytics: Setting team data:', data);
      state.teamData = data;
    },

    SET_LOADING(state, isLoading) {
      console.log('🔄 GM Performance Analytics: Setting loading state:', isLoading);
      state.isLoading = isLoading;
    },

    SET_ERROR(state, error) {
      console.log('❌ GM Performance Analytics: Setting error:', error);
      state.error = error;
    },

    CLEAR_ERROR(state) {
      console.log('✅ GM Performance Analytics: Clearing error');
      state.error = null;
    }
  },

  actions: {
    async fetchPerformanceData({ commit }, filters = {}) {
      try {
        console.log('⚡ GM Performance Analytics: Fetching performance data...');
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');

        const queryParams = new URLSearchParams(filters);
        const response = await fetch(`/api/v1/accounts/gm_analytics/performance_analytics?${queryParams}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('✅ GM Performance Analytics: Performance data fetched successfully:', result);

        if (result.success) {
          commit('SET_PERFORMANCE_DATA', result.data);
        } else {
          throw new Error(result.error || 'Failed to fetch performance data');
        }

        return result;
      } catch (error) {
        console.error('❌ GM Performance Analytics: Error fetching performance data:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },

  getters: {
    performanceData: (state) => state.performanceData,
    agentData: (state) => state.agentData,
    teamData: (state) => state.teamData,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    hasData: (state) => Object.keys(state.performanceData).length > 0
  }
};

console.log('✅ GM Performance Analytics Store: Module created successfully');

export default performanceAnalytics;
